/**
 * Stackflow instance for the messaging section.
 *
 * Three activities: Messages (list), Chat (detail), NewConversation.
 * historySyncPlugin maps them to /messages/* URLs.
 * stackTransitionPlugin provides iOS-style push/pop transitions.
 */

import { stackflow } from '@stackflow/react';
import { historySyncPlugin } from '@stackflow/plugin-history-sync';
import { stackTransitionPlugin } from './plugins/stackTransitionPlugin';
import MessagesActivity from './activities/MessagesActivity';
import ChatActivity from './activities/ChatActivity';
import NewConversationActivity from './activities/NewConversationActivity';
import NewChannelActivity from './activities/NewChannelActivity';
import ChannelInfoActivity from './activities/ChannelInfoActivity';
import ThreadActivity from './activities/ThreadActivity';
import StarredMessagesActivity from './activities/StarredMessagesActivity';

export const { Stack: MessagingStack, useFlow: useMessagingFlow } = stackflow({
  transitionDuration: 350,
  activities: {
    MessagesActivity,
    ChatActivity,
    NewConversationActivity,
    NewChannelActivity,
    ChannelInfoActivity,
    ThreadActivity,
    StarredMessagesActivity,
  },
  plugins: [
    stackTransitionPlugin(),
    historySyncPlugin({
      routes: {
        MessagesActivity: '/messages',
        NewConversationActivity: '/messages/new',
        NewChannelActivity: '/messages/new-channel',
        StarredMessagesActivity: '/messages/starred',
        ChannelInfoActivity: '/messages/:conversationId/info',
        ThreadActivity: '/messages/:conversationId/thread/:messageId',
        ChatActivity: '/messages/:conversationId',
      },
      fallbackActivity: () => 'MessagesActivity',
    }),
  ],
});
